import { RevLanguageCodes, LanguageNames } from '@vbrick/vb-language-util';

export const srtLanguages = RevLanguageCodes;

export const liveLanguages = srtLanguages.filter(code => code.live);
export const aiServiceLanguages = srtLanguages.filter(code => code.transcription);
export const aiServiceTranslationLanguages = srtLanguages.filter(code => code.translation);
export const rtlLanguages = srtLanguages.filter(code => code.rtl);

export const languageNames = LanguageNames;
